import HomeScreen from './components/HomeScreen'

export default {
  path: '/',
  name: 'Home',
  component: HomeScreen
}



// WEBPACK FOOTER //
// ./src/app/screens/Home/index.js